import React from 'react';
import { Alert, Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import SectionTitle from '../shared/SectionTitle';
import { t } from '../../../../utils/textUtils';

const DocumentsTab = ({ project }) => (
  <>
    <SectionTitle
      title={t('DOKUMEN PENDUKUNG')}
      subtitle={t('Lampiran dan dokumen teknis proyek.')}
    />

    {project.layoutDesainUrl ? (
      <Box sx={{ mb: 3 }}>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
            borderRadius: 2,
            borderColor: 'divider'
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <PictureAsPdfIcon sx={{ color: '#F44336' }} />
            <Box>
              <Typography sx={{ fontWeight: 700 }}>{t('LAYOUT DESAIN')}</Typography>
              <Typography variant="caption" color="text.secondary">
                {t('Klik tombol untuk melihat atau mengunduh file')}
              </Typography>
            </Box>
          </Stack>
          <IconButton size="small" onClick={() => window.open(project.layoutDesainUrl, '_blank')}>
            <DownloadIcon />
          </IconButton>
        </Paper>

        <Box sx={{ width: '100%', height: '500px', border: '1px solid #E0E0E0' }}>
          <iframe
            src={project.layoutDesainUrl}
            width="100%"
            height="100%"
            title="Layout Design"
            style={{ border: 'none' }}
          />
        </Box>
      </Box>
    ) : (
      <Alert severity="info" sx={{ mb: 3 }}>
        {t('TIDAK ADA DOKUMEN TERSEDIA UNTUK PROYEK INI')}
      </Alert>
    )}
  </>
);

export default DocumentsTab;
